export const data = [
  {
    id: 1,
    title: "Puss in Boots: The Last Wish",
    body: "Puss in Boots discovers that his passion for adventure has taken its toll: He has burned through eight of his nine lives, leaving him with only one life left. Puss sets out on an epic journey to find the mythical Last Wish and restore his nine lives.",
    rate: 8.611,
    tags: ["Animation", "Adventure", "Comedy", "Family", "Fantasy"],
    date: 2022,
  },
  {
    id: 2,
    title: "Avatar",
    body: "In the 22nd century, a paraplegic Marine is dispatched to the moon Pandora on a unique mission, but becomes torn between following orders and protecting an alien civilization.",
    rate: 7.564,
    tags: ["Action", "Adventure", "Fantasy", "Sci - Fi"],
    date: 2009,
  },
  {
    id: 3,
    title: "The Shawshank Redemption",
    body: "Framed in the 1940s for the double murder of his wife and her lover, upstanding banker Andy Dufresne begins a new life at the Shawshank prison, where he puts his accounting skills to work for an amoral warden. During his long stretch in prison, Dufresne comes to be admired by the other inmates -- including an older prisoner named Red -- for his integrity and unquenchable sense of hope.",
    rate: 8.7,
    tags: ["Drama"],
    date: 1994,
  },
  {
    id: 4,
    title: "The Godfather",
    body: "Spanning the years 1945 to 1955, a chronicle of the fictional Italian-American Corleone crime family. When organized crime family patriarch, Vito Corleone barely survives an attempt on his life, his youngest son, Michael steps in to take care of the would-be killers, launching a campaign of bloody revenge.",
    rate: 8.714,
    tags: ["Crime", "Drama"],
    date: 1972,
  },
];
